/**
 * Created by pajicv on 10/25/18.
 */
import React from 'react';
import { Paper, withStyles, Slide } from '@material-ui/core';
import onClickOutside from "react-onclickoutside";

const styles = theme => ({
    paper: {
        background: '#fff',
        width: '96%',
        position: 'fixed',
        top: 200,
        bottom: 5,
        left: '2%'
    },
    paperCollapsed: {
        width: '98%',
        position: 'absolute',
        bottom: 5,
        left: '1%'
    },
    container: {
        width: '100%',
        height: '100%',
        overflow: 'auto',
    }
});

class OverlayLevel2 extends React.Component {

    handleClickOutside = evt => {
        const { onClickOutsideOverlay } = this.props;
        onClickOutsideOverlay();
    };

    handleClickInside = evt => {
        const { onClickInsideOverlay } = this.props;
        onClickInsideOverlay();
    };

    render() {
        const { props: { children, classes, selectedTask, taskOverlayCollapsed } } = this;
        return (
            <Slide direction="up" in={Boolean(selectedTask)} mountOnEnter unmountOnExit>
                <Paper style={{zIndex: 199}}
                        elevation={24}
                       className={!taskOverlayCollapsed ? classes.paper : classes.paperCollapsed}
                >
                    <div className={classes.container} onClick={this.handleClickInside}>
                        {children}
                    </div>
                </Paper>
            </Slide>
        );
    }

}

export default withStyles(styles)(onClickOutside(OverlayLevel2));


// WEBPACK FOOTER //
// ./src/components/Overlay/OverlayLevel2.js